export default {
  "fiber-500m": {
    title: "Fiber 500",
    name: "Fiber 500",
    hash: "fiber-500",
    productId: "cab64815-9698-4413-8384-32b2a8e611a4",
    legal: {
      proximity: "per month for 24 months with Auto Pay",
      short: "per month for 24 months with Auto Pay",
      tooltip: "ag-legal-500m",
      hash: "new-residential-only-500",
    },
  },
  "fiber-gig": {
    title: "Fiber Gig",
    name: "Fiber 1 Gig",
    hash: "fiber-gig",
    productId: "06437f7d-ba48-435e-b2ec-11358916000c",
    legal: {
      proximity: "per month for 24 months with Auto Pay",
      short: "per month for 24 months with Auto Pay",
      tooltip: "ag-legal-gig",
      hash: "Gig-new-residential",
    },
  },
  "fiber-2-gig": {
    title: "Fiber 2 Gig",
    name: "Fiber 2 Gig",
    hash: "fiber-2-gig",
    productId: "79ff85b4-0ead-4e4d-ab83-34edad43bdbc",
    legal: {
      proximity: "per month for 24 months with Auto Pay",
      short: "per month for 24 months with Auto Pay",
      tooltip: "ag-legal-2gig",
      hash: "2g-service",
    },
  },
  "fiber-5-gig": {
    title: "Fiber 5 Gig",
    name: "Fiber 5 Gig",
    hash: "fiber-5-gig",
    productId: "07e39c54-0093-4d94-ab10-ebba184e6694",
    legal: {
      proximity: "per month for 24 months with Auto Pay",
      short: "per month for 24 months with Auto Pay",
      tooltip: "ag-legal-5gig",
      hash: "5g-service",
    },
  },
  "fiber-7-gig": {
    title: "Fiber 7 Gig",
    name: "Fiber 7 Gig",
    hash: "fiber-7-gig",
    productId: "4cb4994c-e947-404d-926a-14f0674490cb",
    legal: {
      proximity: "per month for 24 months with Auto Pay",
      short: "per month for 24 months with Auto Pay",
      tooltip: "auto-pay",
      hash: "7g-service",
    },
  },
};
